import type { AssignmentSuggestion } from '@chukua/common';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useToast } from '../../../shared/hooks/use-toast';
import { assignCrew } from '../dispatch.api';
import { dispatchPaths } from '../dispatch.paths';
import type { SuggestionWindow } from '../policies/suggestion-window.policy';

/** Choosing a row assigns that crew; the server judges it again, so a 409 (taken meanwhile) is reported and the list stays for another pick. */
export function useChooseCrew(tripId: string, window: SuggestionWindow) {
  const [chosenRank, setChosenRank] = useState<number | null>(null);
  const toast = useToast();
  const navigate = useNavigate();

  async function choose(suggestion: AssignmentSuggestion): Promise<void> {
    setChosenRank(suggestion.rank);
    try {
      await assignCrew(tripId, { truckId: suggestion.truck.id, trailerId: suggestion.trailer.id, driverId: suggestion.driver.id }, window);
      toast.success(`Trip assigned to ${suggestion.truck.registration} and ${suggestion.driver.name}`);
      navigate(dispatchPaths.dispatchTrip(tripId));
    } catch {
      toast.error('Could not assign that crew — it may have been taken. Reload the suggestions and pick again.');
      setChosenRank(null);
    }
  }

  return { choose, chosenRank };
}
